const redirects: any = {
  '/': '/dashboard/overall',
  '/dashboard': '/dashboard/overall',
  // '/analytics': '/analytics/eia',
  '/analytic': '/analytic/eia',
  '/configuration': '/configuration/device',
  '/alerts': '/alerts/overall',
  '/settings': '/settings/overall',
  '/deviceInfo': '/deviceInfo/overall',
}

const smcRedirect: any = {
  '/': '/dashboard'
}

export default defineNuxtRouteMiddleware(async (to, from) => {
  let redirectPath: any = null;

  if (useSubdomain() === 'admin') return;

  const { value } = await useTenant();


  if (value.solution === 'SMC') {
    redirectPath = smcRedirect[to.path];
  } else {
    redirectPath = redirects[to.path];
  }

  if (to.path.startsWith('/analytics')) {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' });
  }
   if (to.path.startsWith('/monitoring-config')) {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' });
  }

  if (redirectPath) {
    return navigateTo(redirectPath);
  }
})